<script setup lang="ts">
import { CollapsibleRoot } from 'radix-vue'

import {
  CollapsibleContent,
  CollapsibleTrigger,
} from '../components/Collapsible'

const open = defineModel<boolean>('open', { default: true })
</script>

<template>
  <CollapsibleRoot
    v-model:open="open"
    class="flex flex-col gap-y-[clamp(0.25rem,0.75vh,0.75rem)]"
  >
    <CollapsibleContent class="flex items-center">
      <slot />
      <div class="z-20 flex flex-1 items-center justify-end gap-2">
        <slot name="actions" />
      </div>
    </CollapsibleContent>

    <div class="flex gap-x-2">
      <CollapsibleTrigger :isOpen="open" />

      <slot name="toolbar" />
    </div>
  </CollapsibleRoot>
</template>
